export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/google_data_studio.7ea35c9.svg";